import { Modal } from '@/components/Modal';

import LogoSvg from '@/assets/breitling-simple.svg';

import * as S from './BoutiqueDeliveryModal.styles';
export interface PriceModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
}
export const BoutiqueDeliveryModal = ({
  children,
  isOpen,
  onClose,
}: PriceModalProps) => {
  return (
    <Modal
      data-test-id='BoutiqueDeliveryModal-Modal'
      isOpen={isOpen}
      maxWidth='md'
      onClose={onClose}
    >
      <Modal.Header
        data-test-id='BoutiqueDeliveryModal-ModalHeader'
        onClose={onClose}
      >
        <S.Logo
          alt='Breitling logo'
          data-test-id='BoutiqueDeliveryModal-Logo'
          height={50}
          src={LogoSvg}
          width={50}
        />
      </Modal.Header>
      <Modal.Body data-test-id='BoutiqueDeliveryModal-ModalBody'>
        <S.Body data-test-id='BoutiqueDeliveryModal-Body'>{children}</S.Body>
      </Modal.Body>
    </Modal>
  );
};
